import React from 'react';

import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  MenuItem,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';

import ReactCountryFlag from 'react-country-flag';

import {useSelectedCountry} from '../contexts/CountryContext';
import {getCountryCode} from '../utils/countryMappings';

export function CountrySelectorDrawer() {
  const {selectedCountry, setSelectedCountry, countries} = useSelectedCountry();
  const {isOpen, onOpen, onClose} = useDisclosure();

  if (countries.length <= 1 || !selectedCountry) {
    return null;
  }

  return (
    <>
      <MenuItem
        icon={
          <ReactCountryFlag
            countryCode={getCountryCode(selectedCountry.id)}
            svg
            style={{
              width: '1.2em',
              height: '1.2em',
            }}
          />
        }
        onClick={onOpen}>
        {selectedCountry.name}
      </MenuItem>

      <Drawer isOpen={isOpen} placement='bottom' onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg='white' color='gray.800'>
          <DrawerHeader borderBottomWidth='1px' color='gray.800'>
            Seleccionar País
          </DrawerHeader>
          <DrawerBody py={4}>
            <VStack spacing={2} align='stretch'>
              {countries.map(country => (
                <Button
                  key={country.id}
                  onClick={() => {
                    setSelectedCountry(country);
                    onClose();
                  }}
                  variant={
                    selectedCountry.id === country.id ? 'solid' : 'ghost'
                  }
                  colorScheme={
                    selectedCountry.id === country.id ? 'blue' : undefined
                  }
                  color={
                    selectedCountry.id === country.id ? 'white' : 'gray.800'
                  }
                  leftIcon={
                    <ReactCountryFlag
                      countryCode={getCountryCode(country.id)}
                      svg
                      style={{
                        width: '1.2em',
                        height: '1.2em',
                      }}
                    />
                  }
                  w='100%'
                  justifyContent='flex-start'
                  size='lg'
                  py={6}>
                  {country.name}
                </Button>
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
